import { render } from "./SoftwareView.vue?vue&type=template&id=543a9c94&scoped=true"
import script from "./SoftwareView.vue?vue&type=script&lang=js"
export * from "./SoftwareView.vue?vue&type=script&lang=js"

import "./SoftwareView.vue?vue&type=style&index=0&id=543a9c94&scoped=true&lang=css"

import exportComponent from "C:\\source\\LETC\\CorpWebsite\\LETC_vr_Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543a9c94"]])

export default __exports__